﻿export default {
    data() {
        return {
            errors: [],
            loading: false,
            wasSubmitted: false,
        };
    },
    methods: {
        async submit() {
            this.errors = [];

            if (this.v$ && this.v$.$invalid) {
                this.v$.$touch();
                return;
            }

            this.loading = true;

            try {
                await this.onSubmit();
            }
            catch (errors) {
                this.showErrorMessages(errors);
            }
            finally {
                this.loading = false;
            }
        },

        async onSubmit() { },

        showErrorMessages(errors) {
            for (let i = 0; i < errors.length; i++)
                this.$root.errorToast(errors[i]);
        }
    }
};